<template>
    <div class="reference">
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="first name"
                rules="required"
            >
                <C1FormInput
                    id="firstName"
                    :label="$t('label.first_name')"
                    label-for="firstName"
                    v-model="form.first_name"
                    name="firstName"
                    :placeholder="$t('label.first_name_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="last name"
                rules="required"
            >
                <C1FormInput
                    id="lastName"
                    :label="$t('label.last_name')"
                    label-for="lastName"
                    v-model="form.last_name"
                    name="lastName"
                    :placeholder="$t('label.last_name_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="position"
                rules="required"
            >
                <C1FormInput
                    id="position"
                    :label="$t('label.position')"
                    label-for="position"
                    v-model="form.position"
                    name="position"
                    :placeholder="$t('label.position_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="company"
                rules="required"
            >
                <C1FormInput
                    id="company"
                    :label="$t('label.company')"
                    label-for="company"
                    v-model="form.company"
                    name="company"
                    :placeholder="$t('label.company_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="phone number"
                :rules="{ regex: /^([0-9() +.-]){5,15}$/ }"
            >
                <C1FormInput
                    id="phone_number"
                    :label="$t('label.phone_number')"
                    label-for="phone_number"
                    v-model="form.phone_number"
                    name="phone_number"
                    :placeholder="$t('label.phone_number_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="mobile number"
                :rules="{ required: true, regex: /^([0-9() +.-]){5,15}$/ }"
            >
                <C1FormInput
                    id="mobile_number"
                    :label="$t('label.mobile_number')"
                    label-for="mobile_number"
                    v-model="form.mobile_number"
                    name="mobile_number"
                    :placeholder="$t('label.mobile_number_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{ errors }"
                name="email address"
                rules=""
            >
                <C1FormInput
                    id="email_address"
                    :label="$t('label.email_address')"
                    label-for="email_address"
                    v-model="form.email_address"
                    name="email_address"
                    :placeholder="$t('label.email_address_placeholder')"
                    :is-invalid="!!errors[0]"
                    :invalid-feedback="errors[0]"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{}"
                name="report directly"
                rules=""
            >
                <C1Label class="afu-font-bold">
                    {{ $t('label.is_report_directly') }}
                </C1Label>

                <C1RadioButton
                    :options="yes_no_options"
                    :current-value="form.is_report_directly"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <ValidationProvider
                v-slot="{}"
                name="contactable"
                rules=""
            >
                <C1Label class="afu-font-bold">
                    {{ $t('label.is_contactable') }}
                </C1Label>

                <C1RadioButton
                    :options="yes_no_options"
                    :current-value="form.is_contactable"
                />
            </ValidationProvider>
        </C1FormGroup>
        <C1FormGroup>
            <AfTerms :terms="getTerms" />
        </C1FormGroup>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import moment from 'moment/src/moment';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import C1RadioButton from '@/components/C1Components/C1RadioButton';
    import C1Label from '@/components/C1Components/C1Label';
    import { ValidationProvider } from 'vee-validate';
    import AfTerms from '@/components/Partials/AfTerms';

    export default {
        name: 'ReferenceForm',

        components: {
            C1FormGroup,
            C1FormInput,
            C1Label,
            C1RadioButton,
            ValidationProvider,
            AfTerms,
        },

        props: {
            reference: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },

        data() {
            return {
                form: {
                    id: null,
                    first_name: '',
                    last_name: '',
                    position: '',
                    company: '',
                    phone_number: '',
                    mobile_number: '',
                    email_address: '',
                    is_report_directly: { value: false },
                    is_contactable: { value: false },
                },
                yes_no_options: [
                    { label: 'No', value: false },
                    { label: 'Yes', value: true },
                ],
            };
        },

        computed: {
            getTerms() {
                const terms = [
                    {
                        id: 1,
                        content:
                            'I declare that the information I have provided is accurate and true to the best of my knowledge.',
                        display_checkbox: true,
                        prechecked: false,
                        required_field: true,
                    },
                    {
                        id: 2,
                        content:
                            'I consent to the use and disclosure of my personal data to third parties based in any country for the purpose of conducting reference checks.',
                        display_checkbox: true,
                        prechecked: false,
                        required_field: true,
                    },
                ];
                return terms;
            },
        },

        watch: {
            form: {
                handler() {
                    this.onDataChange();
                },
                deep: true,
            },
        },

        created() {
            this.getInitialData();
            this.fillForm();
        },

        methods: {
            ...mapActions('attribute', {}),

            getInitialData() {},

            fillForm() {
                if (this.reference.id) {
                    this.form.id = this.reference.id;
                    this.form.first_name = this.reference.first_name;
                    this.form.last_name = this.reference.last_name;
                    this.form.position = this.reference.position;
                    this.form.company = this.reference.company;
                    this.form.phone_number = this.reference.phone_number;
                    this.form.mobile_number = this.reference.mobile_number;
                    this.form.email_address = this.reference.email_address;
                    this.form.is_report_directly = {
                        value: this.reference.is_report_directly,
                    };
                    this.form.is_contactable = {
                        value: this.reference.is_contactable,
                    };
                }
            },

            dateFormatter(date) {
                return moment
                    .utc(date)
                    .local()
                    .format('MMMM YYYY');
            },

            onDataChange() {
                this.$emit('change', this.form);
            },
        },
    };
</script>
